<script>
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters([
      'isAuth'
    ]),
  },
  created() {
    if (this.$route.meta.auth == 'not' && this.isAuth)
      this.$router.push('/')

    if (this.$route.meta.auth == 'yes' && !this.isAuth)
      this.$router.push('/auth/')
  }
}
</script>